/**
 * Used for application level network calls failing
 */
export class LoadingError extends Error {}
